(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper')
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection-template"]) return;
  try {
    
    // Ajaxinate pagination setup
    const getpagi = document.querySelector('.AjaxinatePagination');
    if(typeof(getpagi) !== "undefined" && getpagi !== null){
      document.addEventListener("DOMContentLoaded", function() {
        const elem = getpagi.getAttribute('data-pagination');
        var endlessScroll = new Ajaxinate({
          container: '.AjaxinateLoop',
          pagination: '.AjaxinatePagination',
          loadingText: '<span class="loader-line"></span>',
          method: elem == 'scroll' ? 'scroll' : 'click',
          callback: function() {
            // Re-initialize variant selectors after new items are loaded via AJAX
            if (typeof window.initCollectionVariantSelectors === 'function') {
              setTimeout(window.initCollectionVariantSelectors, 300);
            }
          }
        });
      });
    }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      console.log('');
      console.log('=== PRODUCT RECOMMENDATIONS ELEMENT CONSTRUCTED ===');
      console.log('Data URL:', this.dataset.url);

      const handleIntersection = (entries, observer) => {
        console.log('Intersection handler called');
        console.log('Is intersecting:', entries[0].isIntersecting);
        
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        console.log('Fetching recommendations from:', this.dataset.url);

        fetch(this.dataset.url)
          .then(response => {
            console.log('Recommendations response received');
            return response.text();
          })
          .then(text => {
            console.log('Recommendations HTML received, length:', text.length);
            
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');

            console.log('Recommendations element in response:', !!recommendations);

            if (recommendations && recommendations.innerHTML.trim().length) {
              console.log('Replacing content with recommendations');
              this.innerHTML = recommendations.innerHTML;
              console.log('Content replaced');
              
              // CRITICAL: Extract and execute the variant data script from the response
              console.log('Looking for variant data script in response...');
              const scripts = html.querySelectorAll('script');
              console.log('Found', scripts.length, 'script tags in response');
              
              scripts.forEach((script, index) => {
                const scriptContent = script.textContent;
                if (scriptContent.includes('recommendationVariants')) {
                  console.log('Found variant data script at index', index);
                  console.log('Executing variant data script...');
                  try {
                    eval(scriptContent);
                    console.log('✓ Variant data script executed');
                    console.log('Window recommendationVariants after execution:', window.recommendationVariants);
                  } catch (e) {
                    console.error('Error executing variant data script:', e);
                  }
                }
              });
            }

            if (html.querySelector('.grid__item')) {
              console.log('Adding product-recommendations--loaded class');
              this.classList.add('product-recommendations--loaded');
            }
            
            console.log('Waiting 300ms before initializing variant selectors...');
            
            // Initialize variant selectors after recommendations load
            if (typeof window.initRecommendationsVariantSelectors === 'function') {
              setTimeout(function() {
                console.log('');
                console.log('=== CALLING VARIANT SELECTOR INIT AFTER AJAX LOAD ===');
                console.log('Window recommendation variants:', window.recommendationVariants);
                if (window.recommendationVariants) {
                  console.log('Variant data available for', Object.keys(window.recommendationVariants).length, 'products');
                }
                window.initRecommendationsVariantSelectors();
              }, 300);
            } else {
              console.error('initRecommendationsVariantSelectors function not found!');
            }
            
            if (window.SPR && theme.review ) {
              if ($('.shopify-product-reviews-badge').length > 0) {
                return window.SPR.registerCallbacks(), window.SPR.initRatingHandler(), window.SPR.initDomEls(), window.SPR.loadProducts(), window.SPR.loadBadges();
              };
            }
          })
          .catch(e => {
            console.error('Error loading recommendations:', e);
          });
      }

      console.log('Setting up intersection observer');
      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 500px 0px'}).observe(this);
    }
  }

  console.log('Defining product-recommendations custom element');
  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-template-1"]) return;
  try {
    
var initPhotoSwipeFromDOM = function(gallerySelector) {
  var parseThumbnailElements = function(el) {
    var thumbElements = Array.prototype.slice.call(document.querySelectorAll('.photo-image')),
      numNodes = thumbElements.length,
      items = [],
      figureEl,
      linkEl,
      size,
      item;
    for (var i = 0; i < numNodes; i++) {
      figureEl = thumbElements[i];
      if (figureEl.nodeType !== 1) continue;
      linkEl = figureEl.children[0];
      if(linkEl.getAttribute('data-size')){ size = linkEl.getAttribute('data-size').split('x'); } else { size = []; }
      item = { src: linkEl.getAttribute('href'), w: parseInt(size[0], 10), h: parseInt(size[1], 10) };
      if (figureEl.children.length > 1) item.title = figureEl.children[1].innerHTML;
      if (linkEl.children.length > 0) item.msrc = linkEl.children[0].getAttribute('src');
      item.el = figureEl;
      items.push(item);
    }
    return items;
  };
  var closest = function closest(el, fn) { return el && (fn(el) ? el : closest(el.parentNode, fn)); };
  var onThumbnailsClick = function(e) {
    e = e || window.event;
    e.preventDefault ? e.preventDefault() : e.returnValue = false;
    var eTarget = e.target || e.srcElement;
    var clickedListItem = closest(eTarget, function(el) { return (el.tagName && el.tagName.toUpperCase() === 'FIGURE'); });
    if (!clickedListItem) return;
    var clickedGallery = clickedListItem.parentNode, childNodes = clickedListItem.parentNode.childNodes, numChildNodes = childNodes.length, nodeIndex = 0, index;
    for (var i = 0; i < numChildNodes; i++) {
      if (childNodes[i].nodeType !== 1) continue;
      if (childNodes[i] === clickedListItem) { index = nodeIndex; break; }
      nodeIndex++;
    }
    if (index >= 0) openPhotoSwipe(index, clickedGallery);
    return false;
  };
  var photoswipeParseHash = function() {
    var hash = window.location.hash.substring(1), params = {};
    if (hash.length < 5) return params;
    var vars = hash.split('&');
    for (var i = 0; i < vars.length; i++) {
      if (!vars[i]) continue;
      var pair = vars[i].split('=');
      if (pair.length < 2) continue;
      params[pair[0]] = pair[1];
    }
    if (params.gid) params.gid = parseInt(params.gid, 10);
    return params;
  };
  var openPhotoSwipe = function(index, galleryElement, disableAnimation, fromURL) {
    var pswpElement = document.querySelectorAll('.pswp')[0], gallery, options, items;
    items = parseThumbnailElements(galleryElement);
    options = { maxSpreadZoom: 1, bgOpacity: 0.7, zoomEl: true, history: false, pinchToClose: false, closeOnScroll: false, galleryUID: galleryElement.getAttribute('data-pswp-uid') };
    if (fromURL) {
      if (options.galleryPIDs) { for (var j = 0; j < items.length; j++) { if (items[j].pid == index) { options.index = j; break; } } }
      else { options.index = parseInt(index, 10) - 1; }
    } else { options.index = parseInt(index, 10); }
    if (isNaN(options.index)) return;
    if (disableAnimation) options.showAnimationDuration = 0;
    gallery = new PhotoSwipe(pswpElement, PhotoSwipeUI_Default, items, options);
    gallery.init();
  };
  var galleryElements = document.querySelectorAll(gallerySelector);
  for (var i = 0, l = galleryElements.length; i < l; i++) {
    galleryElements[i].setAttribute('data-pswp-uid', i + 1);
    galleryElements[i].onclick = onThumbnailsClick;
  }
  var hashData = photoswipeParseHash();
  if (hashData.pid && hashData.gid) openPhotoSwipe(hashData.pid, galleryElements[hashData.gid - 1], true, true);
};
initPhotoSwipeFromDOM('.my-gallery');

  } catch(e) { console.error(e); }
})();
})();
